

export const blocksOnClick = (editor) => {
    editor.on('block:click', (block) => {
        const wrapper = editor.getWrapper();
        const allComponents = wrapper.components();
        const lastComponent = allComponents.length > 0 ? allComponents.at(allComponents.length - 1) : null;

        let targetParent = wrapper;

        if (lastComponent) {
            const type = lastComponent.get('type');
            const classes = lastComponent.getClasses() || [];
            const isSection =
                type === 'section' ||
                classes.includes('sio-section') ||
                classes.includes('section');

            if (isSection) {
                const sectionChildren = lastComponent.components();
                const container = sectionChildren.find((comp) => {
                    const compClasses = comp.getClasses() || [];
                    return compClasses.includes('container');
                });
                if (container) {
                    targetParent = container;
                }
            }
        }

        const rawContent = block.get('content');
        const content = typeof rawContent === 'function' ? rawContent() : rawContent;
        if (!content) return;
        targetParent.components().add(content);
    });
}